import {Dialog, DialogProps} from '@mui/material';
import React from 'react';

export const EDialog = (props: DialogProps): React.ReactElement => (
  <Dialog
    {...props}
    PaperProps={{
      style: {
        ...props.style,
        maxWidth: 'none',
        borderRadius: '0px',
      },
    }}
    transitionDuration={0}
  />
);
